import { Component, ojs, v, app, payload } from "modular-openscriptjs";
import { uc } from "../declarations";
import { either, empty, lastOf, showActionButton } from "../helpers";
import LogisticsCompanyForm from "./Forms/LogisticsCompanyForm";

const broker = app("broker");
const h = app("h");
const $e = app("$e");

ojs(LogisticsCompanyForm);

export default class LogisticsCompany extends Component {
	render(addresses, ...args) {
		if (empty(addresses.value)) return "";

		return h.div(
			v(uc.logisticsCompany, (company) => {
				company = company.value;
				return either(
					company.id,
					() =>
						h.div(
							{ class: "d-flex flex-column gap-3" },
							h.LogisticsCompanyView(company, {
								class: "bg-white shadow-sm border rounded-3 p-3",
								useSelectedFleet: true,
								hook: `lcv-selected-${company.id}`,
								lcvActiveFleet: false,
							}),
							h.button(
								{
									class: "btn btn-outline-secondary w-100 border-0 rounded-pill py-2 fw-medium",
									listeners: {
										click: () =>
											broker.send(
												$e.user.needs.to
													.selectLogisticsCompany,
												payload({
													addressId: lastOf(
														addresses.value
													)?.id,
													fleet: uc.fleetType.value,
												})
											),
									},
								},
								h.span(
									h.i({
										class: "fas fa-sync-alt me-2",
									}),
									"Change Delivery Method"
								)
							),
							...args
						),
					() => {
						setTimeout(() => {
							let elem = h.span(
								{
									class: "d-flex align-items-center justify-content-between gap-2",
								},
								h.span(
									{
										class: "d-flex gap-2 align-items-center",
									},
									h.i({ class: "fas fa-truck-fast" }),
									h.span("Select Delivery Company")
								),
								h.i({ class: "fas fa-arrow-right" })
							);

							showActionButton((Action, callbackId) => {
								Action.closeForm(callbackId);

								broker.send(
									$e.user.needs.to.selectLogisticsCompany,
									payload({
										addressId: lastOf(addresses.value)?.id,
										fleet: uc.fleetType.value,
									})
								);
							}, elem.outerHTML);
						}, 1500);

						return h.div(
							h.button(
								{
									class: "btn btn-outline-primary w-100 py-3 rounded-pill shadow-sm fw-bold",
									listeners: {
										click: () =>
											broker.send(
												$e.user.needs.to
													.selectLogisticsCompany,
												payload({
													addressId: lastOf(
														addresses.value
													)?.id,
													fleet: uc.fleetType.value,
												})
											),
									},
								},
								h.span(
									h.i({
										class: "fas fa-truck-fast me-2 fa-lg",
									}),
									"Click to Select Delivery"
								)
							),
							...args
						);
					}
				);
			}),
			...args
		);
	}
}
